import FeedbackCollector from '@atlaskit/feedback-collector';
import FeedbackIcon from '@atlaskit/icon/glyph/feedback';
import { colors } from '@atlaskit/theme';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import { defineMessages, InjectedIntlProps, injectIntl } from 'react-intl';

import { DEFAULT_PROPS } from '../clients/feedbackClient';
import { browserMetrics } from '../facade/window';
import Store from '../store';
import FlagStore, { FlagType } from '../store/flagStore';
import UserStore from '../store/userStore';

const FEEDBACK_FLAG_ID = 'feedback';

interface State {
  displayFlag: boolean;
  isOpen: boolean;
}

type Props = {
  flagStore: FlagStore;
  userStore: UserStore;
} & InjectedIntlProps;

@observer
class Feedback extends Component<Props, State> {
  state = {
    displayFlag: false,
    isOpen: false,
  };

  afterSubmit = () => {
    const { flagStore, intl } = this.props;
    flagStore.addFlag({
      description: intl.formatMessage(messages.flagBody),
      id: FEEDBACK_FLAG_ID,
      title: intl.formatMessage(messages.flagTitle),
      type: FlagType.SUCCESS,
    });
  };
  close = () => this.setState({ isOpen: false });

  open = () => this.setState({ isOpen: true });

  render() {
    const { intl, userStore } = this.props;
    const { isOpen } = this.state;

    return (
      <div>
        <div data-test-id="feedback" onClick={this.open}>
          <FeedbackIcon label={intl.formatMessage(messages.feedbackButton)} primaryColor={colors.N700} />
        </div>

        {isOpen && (
          <FeedbackCollector
            onClose={this.close}
            onSubmit={this.afterSubmit}
            email={userStore.email}
            name={userStore.name}
            {...DEFAULT_PROPS}
            additionalFields={[
              {
                id: 'customfield_11698',
                value: JSON.stringify(this.getAdditionalFields(), null, 2),
              },
            ]}
            typeFieldId="customfield_11705"
          />
        )}
      </div>
    );
  }

  private getAdditionalFields() {
    return {
      accountId: this.props.userStore.accountId,
      ...browserMetrics(),
    };
  }
}

export default inject(({ flagStore, userStore }: Store) => {
  return {
    flagStore,
    userStore,
  };
})(injectIntl(Feedback));

const messages = defineMessages({
  feedbackButton: {
    defaultMessage: 'Feedback',
    description: 'Button to launch a dialog to submit feedback',
    id: 'uchi.feedback.button',
  },
  flagBody: {
    defaultMessage: 'Your feedback has been submitted',
    description: 'Body of flag indicating feedback was submitted',
    id: 'uchi.feedback.flagBody',
  },
  flagTitle: {
    defaultMessage: 'Thank you for your feedback!',
    description: 'Title of flag indicating feedback was submitted',
    id: 'uchi.feedback.flagTitle',
  },
});
